import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes, faFilter, faFileMedical, faFlask, faBoxOpen } from '@fortawesome/free-solid-svg-icons';

const OrdenesPrescritas = () => {
    // Dates Helper
    const getPrimerDiaMesAnterior = () => {
        const d = new Date();
        d.setMonth(d.getMonth() - 1);
        d.setDate(1);
        return d.toISOString().split('T')[0];
    };
    const getUltimoDiaMesActual = () => {
        const d = new Date();
        d.setMonth(d.getMonth() + 1);
        d.setDate(0);
        return d.toISOString().split('T')[0];
    };

    const [ordenesOriginales, setOrdenesOriginales] = useState([]);
    const [ordenesFiltradas, setOrdenesFiltradas] = useState([]);
    const [loading, setLoading] = useState(false);

    // States API Request
    const [fechaDesde, setFechaDesde] = useState(getPrimerDiaMesAnterior());
    const [fechaHasta, setFechaHasta] = useState(getUltimoDiaMesActual());

    // States local filters
    const [filtroId, setFiltroId] = useState('');
    const [filtroAutorizacion, setFiltroAutorizacion] = useState('');
    const [filtroPaciente, setFiltroPaciente] = useState('');
    const [filtroProductos, setFiltroProductos] = useState('Todas');

    useEffect(() => {
        cargarOrdenes();
        // eslint-disable-next-line
    }, []);

    const cargarOrdenes = async () => {
        setLoading(true);
        try {
            const response = await authAxios.post('ordenes/mostrar_ordenes_prescritas', {
                fecha_inicial: fechaDesde,
                fecha_final: fechaHasta
            });
            if (response.data?.Status) {
                setOrdenesOriginales(response.data.ordenes);
                setOrdenesFiltradas(response.data.ordenes);
            }
        } catch (error) {
            Swal.fire('Error', 'No se pudieron cargar las órdenes prescritas', 'error');
            console.error(error);
        }
        setLoading(false);
    };

    useEffect(() => {
        aplicarFiltros();
        // eslint-disable-next-line
    }, [filtroId, filtroAutorizacion, filtroPaciente, filtroProductos, ordenesOriginales]);

    const aplicarFiltros = () => {
        let result = [...ordenesOriginales];

        if (filtroId) {
            result = result.filter(o => String(o.id).includes(filtroId));
        }
        if (filtroAutorizacion) {
            result = result.filter(o => String(o.orden_externa || '').includes(filtroAutorizacion));
        }
        if (filtroPaciente) {
            const searchTerms = filtroPaciente.toLowerCase();
            result = result.filter(o =>
                String(o.cedula || '').toLowerCase().includes(searchTerms) ||
                String(o.nombre || '').toLowerCase().includes(searchTerms) ||
                String(`${o.nombre} ${o.apellido} ${o.segundo_apellido}`).toLowerCase().includes(searchTerms)
            );
        }

        if (filtroProductos !== 'Todas') {
            if (filtroProductos === 'Asignados') {
                result = result.filter(o => Number(o.cant_productos) > 0);
            } else if (filtroProductos === 'No Asignados') {
                result = result.filter(o => Number(o.cant_productos) === 0);
            }
        }

        setOrdenesFiltradas(result);
    };

    const limpiarFiltros = () => {
        setFiltroId('');
        setFiltroAutorizacion('');
        setFiltroPaciente('');
        setFiltroProductos('Todas');
    };

    const verOrden = (id, tabla) => {
        window.localStorage.setItem("Archivo", tabla);
        window.localStorage.setItem("TablaId", id);
    };

    const verDetalle = (id, tabla) => {
        window.localStorage.setItem("Archivo", id);
        window.localStorage.setItem("TablaId", tabla);
    };

    return (
        <div className="content-wrapper">
            <div className="content">
                <div className="container-fluid pt-4">

                    {/* Tarjeta de Filtros */}
                    <div className="card shadow-sm mb-4" style={{ borderRadius: '10px' }}>
                        <div className="card-header bg-white border-bottom">
                            <h4 className="card-title text-primary m-0" style={{ fontWeight: '600' }}>
                                <FontAwesomeIcon icon={faFilter} className="me-2" />
                                Auditoría de Prescripciones y Laboratorios
                            </h4>
                        </div>
                        <div className="card-body bg-light">
                            <div className="row g-3">
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">Fecha Desde</label>
                                    <input type="date" className="form-control form-control-sm" value={fechaDesde} onChange={e => setFechaDesde(e.target.value)} />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">Fecha Hasta</label>
                                    <input type="date" className="form-control form-control-sm" value={fechaHasta} onChange={e => setFechaHasta(e.target.value)} />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">Orden Interna</label>
                                    <input type="text" className="form-control form-control-sm" value={filtroId} onChange={e => setFiltroId(e.target.value)} placeholder="Ej: 10" />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">Orden Externa</label>
                                    <input type="text" className="form-control form-control-sm" value={filtroAutorizacion} onChange={e => setFiltroAutorizacion(e.target.value)} placeholder="Ej: 1111" />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-muted small fw-bold">Paciente (Céd/Nom)</label>
                                    <input type="text" className="form-control form-control-sm" value={filtroPaciente} onChange={e => setFiltroPaciente(e.target.value)} placeholder="Cédula o Nombre" />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">Productos</label>
                                    <select className="form-select form-select-sm" value={filtroProductos} onChange={e => setFiltroProductos(e.target.value)}>
                                        <option value="Todas">Todos</option>
                                        <option value="Asignados">Ya Asignados</option>
                                        <option value="No Asignados">Sin Asignar</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12 text-end">
                                    <button className="btn btn-outline-secondary btn-sm" onClick={limpiarFiltros}>
                                        <FontAwesomeIcon icon={faTimes} className="me-1" /> Limpiar Locales
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Tabla de Resultados */}
                    <div className="card shadow-sm" style={{ borderRadius: '10px' }}>
                        <div className="card-header bg-white d-flex justify-content-between align-items-center">
                            <h5 className="card-title m-0 fw-bold">Listado de Órdenes a Auditar ({ordenesFiltradas.length})</h5>
                            <button className="btn btn-primary btn-sm" onClick={cargarOrdenes} disabled={loading}>
                                {loading ? 'Cargando...' : 'Consultar en Base de Datos'}
                            </button>
                        </div>
                        <div className="card-body p-0">
                            <div className="table-responsive">
                                <table className="table table-hover table-striped align-middle m-0" style={{ fontSize: '0.9rem' }}>
                                    <thead className="table-light">
                                        <tr>
                                            <th>Orden Interna</th>
                                            <th>Orden Externa</th>
                                            <th>Fecha Ingreso</th>
                                            <th>Paciente</th>
                                            <th className="text-center">Cant. Laboratorios</th>
                                            <th className="text-center">Cant. Prescripciones</th>
                                            <th className="text-center">Cant. Productos</th>
                                            <th className="text-center">Acciones Auditar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {ordenesFiltradas.length === 0 ? (
                                            <tr>
                                                <td colSpan="8" className="text-center py-5">
                                                    {loading ? <div>Cargando datos...</div> : <div className="text-muted"><FontAwesomeIcon icon={faSearch} size="2x" className="mb-2 d-block mx-auto" /> No hay órdenes con laboratorios ni prescripciones en este rango de fecha.</div>}
                                                </td>
                                            </tr>
                                        ) : (
                                            ordenesFiltradas.map((ord, idx) => (
                                                <tr key={idx}>
                                                    <td className="fw-bold">
                                                        <Link
                                                            className="btn btn-success btn-sm fw-bold"
                                                            to={"/pages/orden/Dubai"}
                                                            target="_blank"
                                                            onClick={() => verOrden(ord.archivo, 200)}
                                                        >
                                                            #{ord.id}
                                                        </Link>
                                                    </td>
                                                    <td>
                                                        <span className="text-primary fw-bold">{ord.orden_externa || '-'}</span>
                                                    </td>
                                                    <td>{ord.fecha_inicial}</td>
                                                    <td>
                                                        <span className="d-block fw-bold">{ord.cedula}</span>
                                                        <Link
                                                            className="text-decoration-none text-secondary fw-bold"
                                                            to={"/pages/detalle/Dubai"}
                                                            target="_blank"
                                                            onClick={() => verDetalle(ord.paciente, 201)}
                                                        >
                                                            {`${ord.nombre} ${ord.segundo_nombre || ''} ${ord.apellido} ${ord.segundo_apellido || ''}`}
                                                        </Link>
                                                        <div className="small text-muted mt-1">EPS ID: {ord.eps}</div>
                                                    </td>
                                                    <td className="text-center">
                                                        {Number(ord.cant_laboratorios) > 0 ? (
                                                            <span className="badge bg-primary fs-6 p-2 rounded-pill">
                                                                <FontAwesomeIcon icon={faFlask} className="me-2" />
                                                                {ord.cant_laboratorios}
                                                            </span>
                                                        ) : (
                                                            <span className="badge bg-secondary">0</span>
                                                        )}
                                                    </td>
                                                    <td className="text-center">
                                                        {Number(ord.cant_prescripciones) > 0 ? (
                                                            <span className="badge bg-info text-dark fs-6 p-2 rounded-pill">
                                                                <FontAwesomeIcon icon={faFileMedical} className="me-2" />
                                                                {ord.cant_prescripciones}
                                                            </span>
                                                        ) : (
                                                            <span className="badge bg-secondary">0</span>
                                                        )}
                                                    </td>
                                                    <td className="text-center">
                                                        {Number(ord.cant_productos) > 0 ? (
                                                            <span className="badge bg-success fs-6 p-2 rounded-pill">
                                                                <FontAwesomeIcon icon={faBoxOpen} className="me-2" />
                                                                {ord.cant_productos}
                                                            </span>
                                                        ) : (
                                                            <span className="badge bg-secondary">0</span>
                                                        )}
                                                    </td>
                                                    <td className="text-center">
                                                        <Link
                                                            className="btn btn-outline-primary btn-sm"
                                                            to={"/pages/orden/Dubai"}
                                                            target="_blank"
                                                            onClick={() => verOrden(ord.archivo, 200)}
                                                            title="Auditar Orden"
                                                        >
                                                            Ingresar a Orden
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default OrdenesPrescritas;